import { TCommonData, TMargin, TWidget, TWidgetProps } from '@libs/types';
import React from 'react';
import loading from '../../animations/loading.json';
import { sanitizeLottieName } from '../../utils/sanitize';
import { getInlineStyles } from '../../utils/styles';
import { useLottieAnimation } from './useLottieAnimation';

type TLoadingAnimation =
    | ({
          isWidget: true;
      } & TWidgetProps<TCommonData>)
    | {
          isWidget: false;
          margin?: TMargin;
      };

export const LoadingAnimation = (props: TLoadingAnimation) => {
    const finalWidget = props.isWidget
        ? props.widget
        : ({
              uid: 'loader',
              options: { margin: props.margin },
          } as TWidget<TCommonData>);
    const sanitizedUid = sanitizeLottieName(finalWidget.uid);
    
    const { element } = useLottieAnimation({
        uid: sanitizedUid,
        animationData: loading,
        loop: true,
        autoplay: true,
    });

    return <div data-test={finalWidget.uid} ref={element} style={getInlineStyles({ margin: finalWidget.options?.margin, height: '80px', width: '80px' })} />;
};
